export interface IAidasVendor {
  id?: number;
  name?: string;
  description?: string | null;
}

export const defaultValue: Readonly<IAidasVendor> = {};
